import loadable from "@loadable/component";
import { useDevToolsVisibility } from "./hooks/useDevToolsVisibility";

/* L'entree par defaut de @tanstack/react-query-devtools rend `null` des que
   NODE_ENV !== "development" : sur test/canary/preprod (builds de prod) il faut
   donc passer par le sous-chemin `/production`, qui rend toujours le panneau.
   `ssr: false` + le gate d'environnement gardent le chunk hors du bundle servi
   aux vrais utilisateurs : il n'est telecharge que la ou les devtools s'affichent. */
const AsyncReactQueryDevtools = loadable(
	() =>
		import(
			/* webpackChunkName: "react-query-devtools" */ "@tanstack/react-query-devtools/production"
		),
	{ resolveComponent: modules => modules.ReactQueryDevtools, ssr: false }
);

export const QueryDevtools = () => {
	const isVisible = useDevToolsVisibility();

	if (!isVisible) {
		return null;
	}

	return <AsyncReactQueryDevtools initialIsOpen={false} />;
};
